import { authApiCall } from '../auth/saga';

export const getPointsBalance = () =>
  authApiCall({
    url: '/users/points-balance/',
    method: 'get',
  });
